import { render } from "./PartyTerminal.vue?vue&type=template&id=a5bfcfe0&scoped=true"
import script from "./PartyTerminal.vue?vue&type=script&lang=js"
export * from "./PartyTerminal.vue?vue&type=script&lang=js"

import "./PartyTerminal.vue?vue&type=style&index=0&id=a5bfcfe0&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5bfcfe0"]])

export default __exports__